// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Awg3","content":"_3VY3h","orderSummary":"_2YbBv","greenTick":"_2A5yK","congratulations":"_2Hr6e","referenceWrapper":"_15Rsk","referenceTitle":"_12nDl","referenceNumber":"_1Q-oq","whatsNextWrapper":"_12SIJ","appointmentRequiredText":"_3jnk2"};


//////////////////
// WEBPACK FOOTER
// ./containers/stages/SuccessStage/styles.scss
// module id = 717
// module chunks = 0